<template>
  <section class="tableWrap">
    <div class="dashWrap">

      <!--      메뉴 목록 -->
      <div class="dashRow">
        <div class="d-flex">
          <div class="dashBx">
            <div>
            홈페이지 메뉴
            </div>
            <tree
                ref="menuTree"
                :options="treeOptions"
                >

              <span class="tree-text" slot-scope="{ node }">
<!--                <template v-if="!node.hasChildren()">-->
<!--                  <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>-->
<!--                  {{ node.text }}-->
<!--                </template>-->

<!--                <template v-else>-->
                <template>
                  <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>
                  {{ node.text }}
                </template>

              </span>

            </tree>

          </div>
          <div class="dashBx">
            <div>
              관리자 메뉴
            </div>
            <tree
                ref="adminMenuTree"
                :options="treeOptions">

              <span class="tree-text" slot-scope="{ node }">
<!--                <template v-if="!node.hasChildren()">-->
<!--                  <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>-->
<!--                  {{ node.text }}-->
<!--                </template>-->

<!--                <template v-else>-->
                <template>
                  <i :class="[node.data.menuIcon ? node.data.menuIcon : node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>
                  {{ node.text }}
                </template>

              </span>

            </tree>
          </div>
        </div>

        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vIconResize" @click="setMapping">
              <v-icon left>mdi mdi-link</v-icon> Role Mapping
            </v-btn>
          </div>
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import LiquorTree from 'liquor-tree';
import menuApi from '@/api/MenuApi';
import roleApi from '@/api/RoleApi';

export default {
  name: 'Menu',
  components: {
    [LiquorTree.name]: LiquorTree,
  },
  props: {
    role: Object
  },
  watch: {
    role: {
      async handler(nv) {

        this.hasMenus = [];
        this.searchRoleId = null;

        if(nv && Object.keys(nv).length > 0) {
          // this.hasMenus = [51, 58, 64];
          this.hasMenus = (await roleApi.getMenus(nv.roleId)).map(m => m.id.menuId);
          // console.log(this.hasMenus);
          this.$refs.menuTree.tree.options.checkbox = true;
          this.$refs.adminMenuTree.tree.options.checkbox = true;
          this.doBoxChecking(this.menus);
          this.doBoxChecking(this.adminMenus);
          this.searchRoleId = nv.roleId;
          // this.menus.forEach(m => {
          //   m.states.checked = true
          //   console.log(m);
          // });
        } else {
          this.hasMenus = [];
          this.$refs.menuTree.tree.options.checkbox = false;
        }
      }
    }
  },
  mounted() {
    const tree = this.$refs.menuTree.tree
    const adminTree = this.$refs.adminMenuTree.tree
    this.loadTreeData('HOME').then(data => {
      this.menus = tree.parse(data);
      this.$set(this.$refs.menuTree, 'model', this.menus);
    });
    this.loadTreeData('ADMIN').then(data => {
      this.adminMenus = adminTree.parse(data);
      this.$set(this.$refs.adminMenuTree, 'model', this.adminMenus);
    });
  },
  data: () => ({
        hasMenus: [],
        treeData: [],
        treeOptions: {
          parentSelect: true,
          propertyNames: {
            state: 'options',
            text: "menuName",
            children: "childMenus"
          },
          dnd:false,
          checkbox: false
        },
        menu: {},
        menus: [],
        adminMenus: [],
        mobileMenus: [],
        chart: {},
        isModify: false,
        flagChartEdit: false,
        treeItem: null,
        addedChart: null,
        editedChart: null,
        deletedChartKey: null,
        searchRoleId:null
      }
  ),
  methods: {
    async getMenu(node) {
      // console.log(node);
      this.treeItem = node;
      this.isModify = true;
    },
    async chartClick(node) {
      this.chart = node;
    },
    async createMenuForm() {
      this.menu = {menuCategory:'HOME'};
      this.chart = {};
      this.isModify = false;
    },
    doBoxChecking(items) {
      items.map(m => {
        m.states.checked = false;
        m.states.indeterminate = false;
        return m;
      }).forEach(m => {
        // console.log(m);
        m.states.checked = this.hasMenus.includes(m.data.menuId);
        if(m.children?.length??0 > 0) {
          this.doBoxChecking(m.children);
        }
      });
    },
    genDataStruct(obj) {
      return {
        menuId : obj.menuId,
        menuName : obj.menuName,
        menuIcon : obj.menuIcon,
        activated : obj.activated
      }
    },
    async loadTreeData(boardCategory) {
      let temp = await menuApi.list(boardCategory);
      temp.forEach(t => this.genTree(t, 1));

      return temp;
    },
    genTree(item, depth) {
      // console.log(this.role)
      item.data = this.genDataStruct(item);
      item.options = {expanded: false, dropable: false, draggable: false};
      item.childMenus?.forEach(t => this.genTree(t, depth+1));
    },
    setMapping() {
      if(!this.searchRoleId) {
        alert("역할을 선택해주세요.");
        return false;
      }
      const checkedHomeMenus = (this.flatList(this.menus)).filter(m=>m.states.checked).map(m=> {return {menuId:m.data.menuId, roleId:this.searchRoleId}});
      const checkedAdminMenus = (this.flatList(this.adminMenus)).filter(m=>m.states.checked).map(m=> {return {menuId:m.data.menuId, roleId:this.searchRoleId}});
      // console.log(result);
      roleApi.mappingMenus(this.searchRoleId, [...checkedHomeMenus, ...checkedAdminMenus]).then(() => {
            alert('저장되었습니다.');
      });
    },
    flatList(items) {
      if(items && items.length > 0) {
        return items.flatMap(i => {

          if(i.children && i.children.length > 0) {
            return [this.flatList(i.children), i].flatMap(i=>i);
          } else {
            return [i]
          }

        });
      } else
        return [];
    }
  },
  async created() {
    // this.menus = await this.treeData;
  }

}
</script>

<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 20%;

  &:first-child {
    margin-right: 2%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 75%;

}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>